// extracted by mini-css-extract-plugin
export default {"root":"AboutCard_variation_root__Sz3f-","grid-columns-3":"AboutCard_variation_grid-columns-3__vwzKQ","flex-between":"AboutCard_variation_flex-between__OWnXx"};